export const DECIMAL_SEPARATORS = [',', '.'] as const;
